import { PenaltySettingAPI } from "../api";

export class PenaltySetting {
  constructor(props) {
    if (props) {
      for (const [key, value] of Object.entries(props)) {
        this[key] = value;
      }
    } else {
      this.penaltySetting = null;
    }
  }
  static async getPenaltySettingByMarket(payload) {
    const { data } = await PenaltySettingAPI.getPenaltySettingByMarket(payload);
    let penaltySetting = new PenaltySetting(data.result);
    return penaltySetting;
  }

  static async createPenaltySetting(payload) {
    const { data } = await PenaltySettingAPI.createPenaltySetting(payload);
    let penaltySetting = new PenaltySetting(data.result);
    return penaltySetting;
  }

  static async updatePenaltySetting(payload) {
    const { data } = await PenaltySettingAPI.updatePenaltySetting(payload);
    let penaltySetting = new PenaltySetting(data.result);
    return penaltySetting;
  }
}
